var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteCheckOutlined = function SvgWhiteCheckOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 13.267 3-2.934 6 4.4S17.6 6.667 30.5 3L32 5.933S17.9 12.387 11 25L2 13.267Z",
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1 11.267 3-2.934 6 4.4S16.6 4.667 29.5 1L31 3.933S16.9 10.387 10 23L1 11.267Z",
    fill: "#FFF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
};
export default SvgWhiteCheckOutlined;